"use strict";
/*
 * Created on 7. 10. 2019
 *
 * Copyright (c) 2019 Etnetera, a.s. All rights reserved.
 * Intended for internal use only.
 * http://www.etnetera.cz
 */

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var AbstractEntityFilter_1 = require("../../core/model/overview/AbstractEntityFilter");
/**
 * Filter for Promotions list/overview page.
 * @author Radek Beran
 */


var PromotionOverviewFilter =
/*#__PURE__*/
function (_AbstractEntityFilter) {
  _inherits(PromotionOverviewFilter, _AbstractEntityFilter);

  function PromotionOverviewFilter(ids, states, filter, select, storeSpecifications, promotionTypeIds, promotionWeekType, weeks, years, themeIds, dateToGte) {
    var _this;

    _classCallCheck(this, PromotionOverviewFilter);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(PromotionOverviewFilter).call(this));
    _this.ids = ids;
    _this.states = states;
    _this.filter = filter;
    _this.select = select;
    _this.storeSpecifications = storeSpecifications;
    _this.promotionTypeIds = promotionTypeIds;
    _this.promotionWeekType = promotionWeekType;
    _this.weeks = weeks;
    _this.years = years;
    _this.themeIds = themeIds;
    _this.dateToGte = dateToGte;
    return _this;
  }

  return PromotionOverviewFilter;
}(AbstractEntityFilter_1.AbstractEntityFilter);

exports.PromotionOverviewFilter = PromotionOverviewFilter;
PromotionOverviewFilter.EMPTY = new PromotionOverviewFilter();